/*
 *
 * Auth actions types.
 *
 */

export const AUTH_AUTHENTICATE_SUCCESS = 'MC_REACT_AUTH_AUTHENTICATE_SUCCESS';
export const AUTH_CLEAR_USER_INFO = 'MC_REACT_AUTH_CLEAR_USER_INFO';
export const AUTH_ERROR = 'MC_REACT_AUTH_ERROR';
export const AUTH_FETCH_BY_TOKEN = 'MC_REACT_AUTH_FETCH_BY_TOKEN';
export const AUTH_FETCHED_BY_TOKEN = 'MC_REACT_AUTH_FETCHED_BY_TOKEN';
export const AUTH_FORGOT_PASSWORD = 'MC_REACT_AUTH_FORGOT_PASSWORD';
export const AUTH_RESET_PASSWORD = 'MC_REACT_AUTH_RESET_PASSWORD';
export const AUTH_SIGN_IN = 'MC_REACT_AUTH_SIGN_IN';
export const AUTH_SIGN_UP = 'MC_REACT_AUTH_SIGN_UP';
export const AUTH_SIGN_OUT = 'MC_REACT_AUTH_SIGN_OUT';
export const AUTH_UPDATE_PASSWORD = 'MC_REACT_AUTH_UPDATE_PASSWORD';
export const AUTH_USER_CONFIRMATION_TOKEN_EXPIRED = 'MC_REACT_AUTH_USER_CONFIRMATION_TOKEN_EXPIRED';
export const AUTH_USER_CONFIRMATION_TOKEN_VALIDATED = 'MC_REACT_AUTH_USER_CONFIRMATION_TOKEN_VALIDATED';
export const AUTH_USER_CONFIRMATION_REQUEST_ERROR = 'MC_REACT_AUTH_USER_CONFIRMATION_REQUEST_ERROR';
export const AUTH_USER_CONFIRMATION_REQUEST_SUCCESS = 'MC_REACT_AUTH_USER_CONFIRMATION_REQUEST_SUCCESS';
export const AUTH_LINK_GOOGLE_REQUEST_SUCCESS = 'MC_REACT_AUTH_LINK_GOOGLE_REQUEST_SUCCESS';
export const AUTH_LINK_GOOGLE_REQUEST_ERROR = 'MC_REACT_AUTH_LINK_GOOGLE_REQUEST_ERROR';
export const AUTH_LINK_FACEBOOK_REQUEST_SUCCESS = 'MC_REACT_AUTH_LINK_FACEBOOK_REQUEST_SUCCESS';
export const AUTH_LINK_FACEBOOK_REQUEST_ERROR = 'MC_REACT_AUTH_LINK_FACEBOOK_REQUEST_ERROR';
export const AUTH_UNLINK_GOOGLE_REQUEST_SUCCESS = 'MC_REACT_AUTH_UNLINK_GOOGLE_REQUEST_SUCCESS';
export const AUTH_UNLINK_GOOGLE_REQUEST_ERROR = 'MC_REACT_AUTH_UNLINK_GOOGLE_REQUEST_ERROR';
export const AUTH_UNLINK_FACEBOOK_REQUEST_SUCCESS = 'MC_REACT_AUTH_UNLINK_FACEBOOK_REQUEST_SUCCESS';
export const AUTH_UNLINK_FACEBOOK_REQUEST_ERROR = 'MC_REACT_AUTH_UNLINK_FACEBOOK_REQUEST_ERROR';
export const AUTH_USER_ACTIVATION_REQUEST_ERROR = 'MC_REACT_AUTH_USER_ACTIVATION_REQUEST_ERROR';
export const AUTH_USER_ACTIVATION_REQUEST_SUCCESS = 'MC_REACT_AUTH_USER_ACTIVATION_REQUEST_SUCCESS';
